import React from 'react';
import PropTypes from 'prop-types';
import { Collapse } from '@material-ui/core';
import { Flex, ListItem, Switch } from '@knockrentals/knock-shared-web-v2';
import { TabSectionHeader } from '../TabSections';
import { TabView } from '../TabView';
import AffordableOverview from './AffordableOverview';
import { IncomeEligibility } from './IncomeEligibility';
import { useAffordable } from './useAffordable';
import { affordablePropTypes } from '../../../prop-types';
import { DETAILS, ENABLED, INCOME_ELIGIBILITY } from './constants';

const Affordable = ({ affordable = {}, updateProperty }) => {
  const {
    addEligibilityRow,
    affordableTabData,
    clearEligibilityRowError,
    clearFieldErrorMessage,
    deleteEligibilityRow,
    handleOnSave,
    handleOnUndo,
    isActionsDisabled,
    updateAffordable,
    updateEligibilityRow,
    updateEnabled,
    validationErrorMessages,
  } = useAffordable({ affordable, updateProperty });

  const enabled = affordableTabData[ENABLED];

  return (
    <TabView
      handleOnSave={handleOnSave}
      handleOnUndo={handleOnUndo}
      isActionsDisabled={isActionsDisabled}
    >
      <Flex flexDirection="column" gap={16}>
        <ListItem
          component="div"
          disableGutters
          endSlot={
            <Switch
              checked={enabled}
              id="enable-affordable-housing"
              inputProps={{ 'aria-label': 'enable affordable housing' }}
              onChange={({ target: { checked } }) => updateEnabled(checked)}
            />
          }
          startSlot={
            <TabSectionHeader
              description="This property offers Affordable Housing or Income Restrictive options."
              title="Affordable Housing Property"
            />
          }
        />

        <Collapse in={enabled}>
          <Flex flexDirection="column" gap={16}>
            <AffordableOverview
              clearFieldErrorMessage={clearFieldErrorMessage}
              details={affordableTabData[DETAILS]}
              updateAffordable={updateAffordable}
              validationErrorMessages={validationErrorMessages}
            />

            <IncomeEligibility
              addEligibilityRow={addEligibilityRow}
              clearEligibilityRowError={clearEligibilityRowError}
              deleteEligibilityRow={deleteEligibilityRow}
              incomeEligibility={affordableTabData[INCOME_ELIGIBILITY]}
              updateEligibilityRow={updateEligibilityRow}
              validationErrorMessages={validationErrorMessages}
            />
          </Flex>
        </Collapse>
      </Flex>
    </TabView>
  );
};

Affordable.propTypes = {
  affordable: affordablePropTypes,
  updateProperty: PropTypes.func,
};

export default Affordable;
